// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"key-information_sub-title__v1BnU","key-information":"key-information_key-information__BKjL2"};